<template>
  <v-content>
    <div id="core-view" style="height: 100%;">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <!-- <div v-if="$route.meta.layout !== 'public'" style="height:70px"/>
    <core-footer v-if="$route.meta.layout !== 'public'" style="position:fixed;background-color:#eee" /> -->
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Dviewconnect'
    }
  }
}
</script>

<style>
#core-view {
  /* padding-bottom: 100px; */
}
</style>
